import RealEstatePageLayout from '../components/partials/RealEstatePageLayout'
import Link from 'next/link'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Breadcrumb from 'react-bootstrap/Breadcrumb'
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import ImageLoader from '../components/ImageLoader'
import { Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import {useTranslation} from "react-i18next";

const AboutPage = () => {
  const { t } = useTranslation('common');

  return (
    <RealEstatePageLayout
      pageTitle={t("Qui sommes-nous?")}
      description={t("Facilykey est un réseau d'agents immobiliers indépendants au Maroc. Découvrez notre approche pour acheter, vendre, louer et estimer votre bien.")}
      activeNav='Pages'
    >
      <Container className='mt-5 mb-md-4 pt-5'>
        {/* Breadcrumbs */}
        <Breadcrumb className='mb-3 pt-md-3'>
          <Breadcrumb.Item linkAs={Link} href='/'>{t("Accueil")}</Breadcrumb.Item>
          <Breadcrumb.Item active>{t("À propos de nous")}</Breadcrumb.Item>
        </Breadcrumb>
      </Container>

      {/* Page header */}
      <Container as='section' className='mb-5 pb-2'>
        <Row className='gy-4 align-items-center justify-content-center'>
          {/* Hero content */}
          <Col xs={{span: 12, order: 'last'}} sm={9} md={{span: 6, order: 'first'}} lg={5} className='text-md-start text-center'>
            <h1 className='mb-4'>{t("L'immobilier associé à la puissance du collectif")}</h1>
            <p className='mb-4 pb-3 fs-lg'>{t("Récemment créé, le réseau Facilykey a pour ambition de devenir un acteur incontournable grâce au concept du réseau de proximité sans agence mais digital. En alliant la proximité à la puissance du digital, FacilyKey c’est aujourd’hui plus de 50 agents au Maroc et plus de 20 salariés œuvrant au siège pour vous accompagner dans la réussite de vos projets immobiliers.")}</p>
          </Col>
          {/* Hero carousel */}
          <Col xs={{span: 12, order: 'first'}} md={{span: 5, order: 'first', offset: 1}} lg={6}>
            <Swiper
              modules={[Navigation, Pagination]}
              navigation
              pagination={{
                el: '#bullets',
                clickable: true
              }}
              spaceBetween={16}
              grabCursor
              loop
            >
              <SwiperSlide className='d-flex'>
                <ImageLoader src='/images/about/hero/01.jpg' width={792} height={510} alt={t("L'immobilier associé à la puissance du collectif")} className='rounded-3' />
              </SwiperSlide>
              <SwiperSlide className='d-flex'>
                <ImageLoader src='/images/about/hero/02.jpg' width={792} height={510} alt={t("L'immobilier associé à la puissance du collectif")} className='rounded-3' />
              </SwiperSlide>
            </Swiper>
            {/* External pagination (bullets) */}
            <div id='bullets' className='swiper-pagination position-relative bottom-0 pt-2 mt-4 mb-lg-3'></div>
          </Col>
        </Row>
      </Container>

      {/* Features (Why choose us?) */}
      <Container as='section' className='text-center text-md-start mb-md-4 mb-xl-5 pb-md-4'>
        <h2 className='h3 mb-4'>{t("Les valeurs FacilyKey")}</h2>
        <Row xs={1} md={3} className='pb-2'>
          <Col>
            <Card className='border-0'>
              <Card.Body>
                <div className='d-inline-block text-primary mb-3'>
                  <i className='fi-map-pins mb-3 fs-1'></i>
                </div>
                <Card.Title as='h5' className='pb-1'>{t("Proximité")}</Card.Title>
                <Card.Text className='mb-0'>{t("Parce qu’un projet immobilier est important dans une vie, la confiance et le lien sont essentiels. Votre agent FacilyKey, spécialiste sur son secteur, sera votre interlocuteur privilégié de la réflexion à l’aboutissement de votre projet immobilier.")}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col>
            <Card className='border-0'>
              <Card.Body>
                <div className='d-inline-block text-primary mb-3'>
                  <i className='fi-users mb-3 fs-1'></i>
                </div>
                <Card.Title as='h5' className='pb-1'>{t("Conseil")}</Card.Title>
                <Card.Text className='mb-0'>{t("Parce que votre projet immobilier est unique, nos agents ont à cœur de comprendre vos besoins, vos exigences et vos critères pour vous accompagner et vous conseiller dans la concrétisation de votre projet d'achat ou de vente.")}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col>
            <Card className='border-0'>
              <Card.Body>
                <div className='d-inline-block text-primary mb-3'>
                  <i className='fi-education mb-3 fs-1'></i>
                </div>
                <Card.Title as='h5' className='pb-1'>{t("Professionnalisme")}</Card.Title>
                <Card.Text className='mb-0'>{t("Parce que nous attachons une grande importance à votre satisfaction, nos conseillers immobiliers sont formés en continu dans une démarche qualité ISO 9001, et ce afin de vous apporter le meilleur des services.")}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      {/* Find property CTA */}
      <Container as='section' className='mb-5 pb-sm-3 pb-lg-4'>
        <div className='bg-secondary rounded-3'>
          <Col xs={12} md={{span: 11, offset: 1}} className='d-flex align-items-center justify-content-between p-md-0 p-2'>
            <div className='me-md-5 py-md-5 px-md-0 p-4' style={{maxWidth: '526px'}}>
              <h2 className='mb-md-4'>
                {t("Tenté par rejoindre l'aventure?")} <br/>
                {t("Devenez agent indépendant")}
              </h2>
              <p className='mb-4 pb-md-3 fs-lg'>{t("Comme nos dizaines de partenaires, rejoignez l'aventure FacilyKey et donnez de l'élan à votre carrière.")}</p>
              <Button as={Link} href='/catalog?category=vendre' size='lg' variant='primary'>
                {t("Rejoindre l'équipe")}
              </Button>
            </div>
            <Col xs={4} className='d-md-block d-none align-self-end px-0'>
              <div className='d-flex flex-shrink-0 mt-n5'>
                <ImageLoader src='/images/about/cta_about.png' width={600} height={600} alt='' />
              </div>
            </Col>
          </Col>
        </div>
      </Container>

    </RealEstatePageLayout>
  )
}

export default AboutPage
